import React from 'react';
import { Box, Typography, Card } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface GradeMetric {
  name: string;
  value: string | number;
  unit?: string;
}

export interface GradeMetricsCardProps {
  title?: string;
  metrics?: GradeMetric[];
  className?: string;
  sx?: object;
}


const titleSx = {
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '10px',
  lineHeight: '1.2',
  color: '#232323',
  textTransform: 'uppercase',
  marginBottom: 2,
  borderBottom: '1px solid #E0E0E0',
  paddingBottom: 1
};

const metricLabelSx = {
  fontFamily: 'Montserrat',
  fontWeight: 400,
  fontSize: '12px',
  color: '#9E9E9E',
  marginBottom: 0.5
};

const metricValueSx = {
  fontFamily: 'Montserrat',
  fontWeight: 500,
  fontSize: '12px',
  color: '#353535',
  lineHeight: '1.2'
};



const GradeMetricsCard: React.FC<GradeMetricsCardProps> = ({
  title = '',
  metrics = [],
  className = '',
  sx = {}
}) => {
  const { t: tAiGrading } = useTranslation('aiGrading_config');

  return (
    <Card
      elevation={0}
      className={className}
      sx={{
        padding: 2,
        borderRadius: 2,
        backgroundColor: '#FFFFFF',
        border: '1px solid #E0E0E0',
        width: '100%',
        ...sx
      }}
    >
      {/* Title */}
      {title && (
        <Typography sx={titleSx}>
          {title}
        </Typography>
      )}

      {/* Metrics */}
      <Box>
        {metrics.map((metric, index) => (
          <Box key={index} mb={index < metrics.length - 1 ? 0.2 : 0} display="flex" gap={1} alignItems="center">
            <Typography sx={metricLabelSx}>
              {metric.name} :
            </Typography>
            <Typography sx={metricValueSx}>
              {
                metric.value ? (typeof metric.value === 'number' ? metric.value.toFixed(2) : metric.value) + (metric.unit ? ` ${metric.unit}` : '') : tAiGrading('na')
              }             
            </Typography>
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default GradeMetricsCard;